import { ReactNode, HTMLProps, FormEvent } from "react";
import useApplication from "../../hooks/useApplication.hooks";

type FormWithLoaderProps = {
    onSubmit: (event: FormEvent<HTMLFormElement>) => void,
    showLoading?: boolean,
    children: ReactNode
} & Omit<HTMLProps<HTMLFormElement>, 'onSubmit'>;

const FormWithLoader: React.FC<FormWithLoaderProps> = (props) => {
    const { children, onSubmit,showLoading, ...rest } = props;
    const { setIsLoading } = useApplication();

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {        
        if (showLoading) {
            setIsLoading(true);
        }

        try {            
            if (onSubmit) {
                onSubmit(event);
            }
        } catch (err) {
            throw err;
        } finally {
            if (showLoading) {
                setIsLoading(false);
            }
        }
    }

    return (
        <form noValidate autoComplete='off' onSubmit={handleSubmit} role='form' {...rest}>
            {children}
        </form>
    );
}

export default FormWithLoader;